import axios from "axios";
import { selectMode } from "../environment";

const ALLOW_REQUESTS_LOGGING = true;
const ALLOW_RESPONSES_LOGGING = true;

const AUTHORIZATION_HEADER_NAME = "token";

const STAGE_BASE_URL = "https://Apis.folloapp.co.il";
const PRODUCTION_BASE_URL = "https://api.folloapp.co.il";

export const BASE_URL = selectMode(PRODUCTION_BASE_URL, STAGE_BASE_URL)

const apiClient = axios.create({
    baseURL: selectMode(PRODUCTION_BASE_URL, STAGE_BASE_URL),
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
    },
    timeout: 50000,
});

export const ApiUtils =
{
    setAuthorizationHeader: (token) => {
        apiClient.defaults.headers[AUTHORIZATION_HEADER_NAME] = token;
    },

    removeAuthorizationHeader: () => {
        delete apiClient.defaults.headers[AUTHORIZATION_HEADER_NAME];
    },

    get: (endpoint) => {
        const { configurations, cancelRequest } = getRequestCancelationConfigurations();

        const token = sessionStorage.getItem('token');
        apiClient.defaults.headers[AUTHORIZATION_HEADER_NAME] = token;


        function startRequest() {
            return handleRequest(() => apiClient.get(endpoint, configurations));
        }

        return { startRequest, cancelRequest };
    },

    post: (endpoint, data, config) => {
        const { configurations, cancelRequest } = getRequestCancelationConfigurations();
        const token = sessionStorage.getItem('token');
        apiClient.defaults.headers[AUTHORIZATION_HEADER_NAME] = token;

        const combinedConfigurations = {
            ...config,
            ...configurations,
        };

        function startRequest() {
            return handleRequest(() => apiClient.post(endpoint, data, combinedConfigurations))
        }

        return { startRequest, cancelRequest };
    },
}

function getRequestCancelationConfigurations() {
    const requestController = new AbortController();

    const configurations = {
        signal: requestController.signal,
    }

    function cancelRequest() {
        requestController.abort();
    }

    return {
        configurations,
        cancelRequest,
    };
}

async function handleRequest(requestFunction) {
    try {
        const response = await requestFunction();

        const data = response.data;
        if (data.Success) {
            return {
                success: true,
                data: response.data,
            }
        }
        else {
            return {
                success: false,
                status: response.status,
                error: response.data,
            }
        }
    }
    catch (error) {
        return {
            success: false,
            error: error,
            status: error.response?.status,
        }
    }
}

apiClient.interceptors.request.use(request => {
    if (process.env.NODE_ENV && ALLOW_REQUESTS_LOGGING) {
        console.log('Starting Request', JSON.stringify(request, null, 2));
    }

    return request;
});

apiClient.interceptors.response.use(response => {
    if (process.env.NODE_ENV && ALLOW_RESPONSES_LOGGING) {
        console.log('Starting Response', JSON.stringify(response, null, 2));
    }

    return response;
});